import React, { useState, useRef, useEffect, useCallback } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ClientSideRowModelModule } from "ag-grid-community";
import { ModuleRegistry } from "ag-grid-community";
import { useLocation, useNavigate } from "react-router-dom";
import PMRService from "../services/pmrservice";
import { useSelector, useDispatch } from "react-redux";
import { Receipts, AccountSettings, WidgetsDashboard } from "pageComponents";
import { toast } from 'react-toastify';
import UploadReports from '../pageComponents/uploadReport.js/uploadreportsclaud';
import MedicationsModal from "pageComponents/dialogs/dashboard/addMedication";
import ViewSharedReports from "pageComponents/user/accessReport/viewsharedreports";
import TopHeader from './topHeader/topHeader';
import LiveChat from "pageComponents/userChat/userChat";
import { ViewTrends } from "pageComponents";
import { trendsGet } from "apiServices/reducer/apiService";

import {
    getgridHeaders,
    getMedicationatDashboard,
    getLabResultatDashboard,
    getVitals,
    getMRSItesReports,
    getAllMRSItesReports,
    getLogUserMenuAnalytics, getProviderforAdvanceSearch, getHospitalsforAdvanceSearch, deleteReports, archiveReport, mrSitesReportsGetByReportID,
    getChatHistory, getMRGroupsMstrlst
} from "apiServices/reducer/apiService";
import {
    SharedReports, Blog, BMIScreen, SecondOpinion, ConfirmationPopup, ShareReportDialog, MedicalCondition,
    ScheduleForChildren, ScheduleByAge, TrueContraindications,
} from "pageComponents";

//import { SharedReports, Blog, BMIScreen, SecondOpinion, VitalsMetabolicsModal, ConfirmationPopup, ShareReportDialog, UserChatIcon } from "pageComponents";

import { AddVitals } from "pageComponents";
import { Dashbaord } from "pages";
import { CTGrid } from ".";
import {
    Image as ImageIcon,
    Droplet,
    Heart,
    FileText,
} from 'lucide-react';
import { CTNavbar, CTDropDownMulti, CTDatePickerRange } from ".";
import { EditReportDialog } from "pageComponents";
import { NoteApp } from ".";
import ReportDisplaySection from './ReportDisplaySection';
import { getReportDownloadFilename, isNonPreviewableReportBlob } from '../utils/utils';

// Custom tooltip styles
const customTooltipStyles = `
    .custom-tooltip {
        background-color: #2c3e50 !important;
        color: white !important;
        border-radius: 8px !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
        border: none !important;
        max-width: 200px !important;
        text-align: center !important;
        opacity: 0.95 !important;
        transition: opacity 0.3s ease-in-out !important;
    }

    .custom-tooltip .tooltip-arrow {
        border-color: #2c3e50 !important;
    }

    
`;

const SEARCH_DEBOUNCE_MS = 500;
const SEARCH_MIN_CHARS = 3;

// Add styles to document
const styleSheet = document.createElement("style");
styleSheet.innerText = customTooltipStyles;
document.head.appendChild(styleSheet);

// Register AG Grid modules
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const ViewReports = (props) => {
    const gridRef = useRef(null);
    const searchDebounceRef = useRef(null);
    const searchRequestIdRef = useRef(0);
    const searchWasActiveRef = useRef(false);
    const reportsGridLoadInflightRef = useRef(0);
    const reportsListRequestIdRef = useRef(0);
    const reportPreviewRequestIdRef = useRef(0);
    const [unreadCount, setUnreadCount] = useState(0); // or get this from your store/api
    const [showChat, setShowChat] = useState(false);
    const iframeRef = useRef(null); // Ref for the iframe
    const previewContainerRef = useRef(null); // <<< Re-add Ref for the preview container
    const [activeTab, setActiveTab] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");
    const [togglePDF, setTogglePDF] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false); // State for fullscreen mode
    const [isReportsGridLoading, setIsReportsGridLoading] = useState(false);

    // Add state for date range picker
    const today = new Date();
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const dispatch = useDispatch()
    const token = useSelector((state) => state.apiService.token);
    const MenuData = useSelector((state) => state.apiService.menuItem);
    const FamilyData = useSelector((state) => state.apiService.familyAccounts);
    const userData = useSelector((state) => state.apiService.login);
    // console.log(userData, "token");
    const menuData = useSelector((state) => state.apiService.sharedReportsValidateCode);

    const isAccess = menuData.role === 'User';
    const [isProvider, setIsProvider] = useState(false);

    useEffect(() => {
        if (!isAccess && userData) {
            setIsProvider(userData.user_type_name === 'Provider');
        } else {
            setIsProvider(false);
        }
    }, [isAccess, userData]);

    useEffect(() => {
        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
        };
    }, []);

    const params = {
        token: isAccess ? menuData.Token : token,
        user_id: isAccess ? menuData.user_id : (isProvider && userData ? props.userID : (userData?.user_id || ''))
    };



    // Add handler for date change
    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        // Optionally: trigger search or other actions when the date changes
        if (start && end) {
            console.log(`Selected Range in ViewReports: ${start.toLocaleDateString()} to ${end.toLocaleDateString()}`);
            // Update viewReportData state with formatted dates
            const formattedStartDate = start.toISOString().split('T')[0];
            const formattedEndDate = end.toISOString().split('T')[0];
            console.log(formattedStartDate, "formattedStartDate")


            setViewReportData(prevData => {
                const updatedData = {
                    ...prevData,
                    ReportDateStart: formattedStartDate,
                    ReportDateEnd: formattedEndDate
                };
                return updatedData;
            });
            console.log(viewReportData, "viewReportData")
        }
    };



    const [showReport, setShowReport] = useState(false);
    const [showDashboard, setShowDashBoard] = useState(true);
    const [showSharedReports, setShowSharedReports] = useState(false);
    const [showBlog, setShowBlog] = useState(false);

    const [showReceipt, setShowReceipt] = useState(false);
    const [showNotes, setShowNotes] = useState(false);


    const [sharedReportsData, setSharedReportsData] = useState([]);
    const [selectedReports, setSelectedReports] = useState([]); // State to keep track of selected checkboxes
    const [validityOptions, setValidityOptions] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null); // for toggling only one open at a time
    const [subItemsMap, setSubItemsMap] = useState([]); // map report.id => subitems
    const [showBMI, setShowBMI] = useState(false);
    const [isCompare, setIsCompare] = useState(false);
    const [rowData, setRowData] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);
    const [rowDatanew, setRowDatanew] = useState([{
        name: "",
        date: "",
        category: "",
        clinic: "",
        url: '',
        reportId: ''
    }]);
    const [isSelectedBloodWork, setIsSelectedBloodWork] = useState(false);

    const [reportData, setReportData1] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
    const [selectedReportName, setSelectedReportName] = useState(null);
    const [selectedReportID, setSelectedReportID] = useState();
    const [chatHistory, setChatHistory] = useState([]);


    const [userId, setUserId] = useState(isProvider ? props.userID : isAccess ? menuData.user_id : userData.user_id)
    const menuItems = [
        { label: 'Imaging', icon: <ImageIcon className="pmr-menu-icon" />, color: "#e0f2fe", id: 2, parent_id: 2, },
        { label: 'Blood work', icon: <Droplet className="pmr-menu-icon" />, color: "#e0f2fe", id: 3, parent_id: 2 },
        { label: 'Cardiology', icon: <Heart className="pmr-menu-icon" />, color: "#e0f2fe", id: 4, parent_id: 2 },
        { label: 'Prescriptions', icon: <FileText className="pmr-menu-icon" />, color: "#e0f2fe", id: 9, parent_id: 2 },
    ];


    const [gridHeaders, setGridHeaers] = useState([
        { name: 'All', id: 0 },
        { name: 'Imaging', id: 2 },
        { name: 'Blood work', id: 3 },
        { name: 'Cardiology', id: 4 },
        { name: 'Gastroenterology', id: 5 },
        { name: 'Neurology', id: 6 },
        { name: 'Prescriptions', id: 9 }
    ]);
    const [rowDataStatus, setRowDataStatus] = useState(true)
    const [showModal, setShowModal] = useState(false);

    //const [medications, setMedicationData] = useState([{ medication: "TEST", frequency: "1", startedFrom: new Date(), comments: 'Test Comment', status: 'Active', dose: '500' },]);

    const [medications, setMedicationData] = useState([]);

    const [medication, setMedications] = useState([]);
    const [provider, setProvider] = useState([]);
    const [hospitals, setHospital] = useState([]);

    const [labResults, setLabResults] = useState([

    ]);
    const handleAddClick = () => {
        setShowModal(true); // Show the modal when "Add" is clicked
    };

    const handleModalClose = () => {
        setShowModal(false); // Hide the modal when "Close" is clicked
    };

    const handleSaveMedications = (updatedMedications) => {
        setMedications(updatedMedications); // Save the updated medications list

        setMedicationData(updatedMedications); // Save the updated medications list

        setShowModal(false); // Close the modal after saving
    };

    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedProviders, setSelectedProviders] = useState([]);
    const [selectedHospitals, setSelectedHospitals] = useState([]);
    const [deleteIcon, setDeleteIcon] = useState(false);
    const [deleteTitle, setDeleteTitle] = useState("");
    const [deleteMessage, setDeleteMessage] = useState("");
    const [archiveGeader, setArchiveGeader] = useState("");
    const [showcloseButton, setShowcloseButton] = useState(false);
    const [showShareReportDialog, setShowShareReportDialog] = useState(false);
    const [showEditReportDialog, setShowEditReportDialog] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [showSecondOpinion, setShowSecondOpinion] = useState(false);
    const [showMedicalCondition, setShowMedicalCondition] = useState(false);
    const [showScheduleForChildren, setShowScheduleForChildren] = useState(false);
    const [showScheduleByAge, setShowScheduleByAge] = useState(false);
    const [showTrueContraindications, setShowTrueContraindications] = useState(false);
    const [showViewSharedReports, setShowViewSharedReports] = useState(false);


    //const [navItems, setnavItems] = useState();

    const [viewReportData, setViewReportData] = useState({
        ReportGroupName: '',
        ProviderName: '',
        HospitalName: '',
        UserID: userId,
        SearchKey: searchQuery,
        ReportDateStart: null,
        ReportDateEnd: null,
        SiteID: '',
        token: isAccess ? menuData.Token : token
    });
    const [logUserMenuAnalyticsData, setLogUserMenuAnalyticsData] = useState({
        MenuID: 3,
        ParentID: 2,
        UserID: 5,
        token: isAccess ? menuData.Token : token
    });
    const [deleteparams, setDeleteparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: isAccess ? menuData.Token : token
    });
    const [archiveparams, setArchiveparams] = useState({
        UserID: userId,
        ReportID: selectedReportID,
        LoginUserID: userId,
        token: isAccess ? menuData.Token : token
    });
    const [pdfUrl, setPDFURL] = useState()
    const [contentType, setContentType] = useState(null)
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state?.data || {};




    const [navItems, setNavItems] = useState([]);
    const [familyItems, setFamilyItems] = useState([]);
    const [showLiveChat, setShowLiveChat] = useState(false);
    const [showViewTrends, setShowViewTrends] = useState(false);



    const [vitalsValues, setVitalsValues] = useState({
        BloodPressure: "",
        HeartRate: "",
        BloodSugar: "",
        Weight: "",
        WaistSize: "",
    });

    const medicationData = [{ medication: 'TEST', frequency: 1, },];
    const [checkedReports, setCheckedReports] = useState({}); // Track individual report selections
    const [reportCheckedOne, setReportCheckedOne] = useState(false);
    const[compareReportOne, setCompareReportOne] = useState();
    const[compareReportTwo, setCompareReportTwo] = useState();

    const reportCheckedatBloodWork = (reportId, checked) => {
        setCheckedReports(prev => {
            const newCheckedReports = {
                ...prev,
                [reportId]: checked
            };
            // Get and print checked report IDs after state update
            const checkedIds = Object.entries(newCheckedReports)
                .filter(([_, isChecked]) => isChecked)
                .map(([id]) => id);
            console.log('Currently checked report IDs:', checkedIds);

            // If the report is being checked, fetch its data
            if (checked) {
                const reportParams = {
                    reportID: reportId,
                    user_id: isAccess ? menuData.user_id : userId,
                    token: isAccess ? menuData.Token : token
                };

                dispatch(mrSitesReportsGetByReportID(reportParams))
                    .then((response) => {
                        console.log(`Fetched data for report ${reportId}:`, response);
                        const resp = response.payload;
                        const blobUrl = URL.createObjectURL(resp);
                    //    setPDFURL(blobUrl);
                        setCompareReportOne(blobUrl);
                        if(compareReportOne){
                            setCompareReportTwo(blobUrl);
                        }

                    })
                    .catch((error) => {
                        console.error(`Error fetching report ${reportId}:`, error);
                    });
            }

            return newCheckedReports;
        });
    }

    // Add a function to get checked report IDs
    const getCheckedReportIds = () => {
        const checkedIds = Object.entries(checkedReports)
            .filter(([_, isChecked]) => isChecked)
            .map(([id]) => id);
        console.log('Selected report IDs:', checkedIds);
        return checkedIds;
    };

    const columnDefs = [
        {
            headerName: "",
            field: "checkbox",
            width: 30,
            cellRenderer: (params) => {
                if (activeTab === "Blood work") {
                    return (
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={checkedReports[params.data.reportId] || false}
                            onChange={(e) => reportCheckedatBloodWork(params.data.reportId, e.target.checked)}
                            style={{ cursor: 'pointer' }}
                        />
                    );
                }
                return null;
            }
        },
        {
            headerName: "Report Name",
            field: "name",
            flex: 2,
            tooltipField: "name",
            headerTooltip: "Report Name",
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span 
                    style={{ 
                        color: "red", 
                        cursor: 'pointer',
                        textDecoration: 'underline'
                    }} 
                    onClick={() => {
                        // Create a mock event object with the row data
                        const mockEvent = {
                            data: params.data
                        };
                        onRowClicked(mockEvent);
                    }}
                >
                    {params.value}
                </span>
            )
        },
    
        {
            headerName: "Report Date",
            field: "date",
            flex: 1,
            tooltipField: "date",
            headerTooltip: "Report Date",
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ) // Render bold text using React
        },
        {
            headerName: "Category",
            field: "category",
            flex: 1,
            tooltipField: "category",
            headerTooltip: "Category",
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ) // Render bold text using React
        },
        {
            headerName: "Clinic/Diagnostics Center",
            field: "clinic",
            flex: 2,
            tooltipField: "clinic",
            headerTooltip: "Clinic/Diagnostics Center",
            sortable: true,
            filter: true,
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold", color: "blue" }}>{params.value}</span>
            ) // Render bold blue text using React
        },
    ];
    const invokeChatHistory = () => {
        setShowLiveChat(true)
        dispatch(getChatHistory(params)).then((resp) => {
            console.log(resp, "for chat history")
            // setChatHistory(resp.payload.Table)
            const chatHistoryData = resp.payload.messages.map(item => ({
                message: item.message,
                sender: item.sender,
                timestamp: item.timestamp
            }))
            setChatHistory(chatHistoryData)
            console.log(chatHistoryData, "for chat history")

        })
    }


    const onRowClicked = (event) => {
        console.log(event.data, "event.data")
        const reportId = event.data.reportId;
        const previewRequestId = reportPreviewRequestIdRef.current + 1;
        reportPreviewRequestIdRef.current = previewRequestId;
        setIsReportPreviewLoading(true);
        setContentType(null);
        setPDFURL((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });
        PMRService.getPMRReportsPerId(reportId).then(async (resp) => {
            if (previewRequestId !== reportPreviewRequestIdRef.current) {
                return;
            }
            if (!(resp instanceof Blob) || await isNonPreviewableReportBlob(resp)) {
                setContentType(null);
                setPDFURL(null);
                setSelectedReport(null);
                setSelectedReportName(null);
                setSelectedReportID(null);
                return;
            }
            setContentType(resp.type || null);
            const blobUrl = URL.createObjectURL(resp);
            console.log('bloburl', blobUrl)
            setPDFURL(blobUrl)

            setSelectedReport(event.data)
            setSelectedReportName(event.data.name)
            setSelectedReportID(event.data.reportId)
            setDeleteparams({
                UserID: userId,
                ReportID: event.data.reportId,
                LoginUserID: userId,
                token: isAccess ? menuData.Token : token
            })
            setArchiveparams({
                UserID: userId,
                ReportID: event.data.reportId,
                LoginUserID: userId,
                token: isAccess ? menuData.Token : token
            })
            console.log(selectedReportID, "selectedReportID")
            console.log(deleteparams, "deleteparams in rowCLick")

        }).catch(error => {
            if (previewRequestId !== reportPreviewRequestIdRef.current) {
                return;
            }
            console.error('Error fetching report:', error);
            setContentType(null);
            setPDFURL(null);
        }).finally(() => {
            if (previewRequestId === reportPreviewRequestIdRef.current) {
                setIsReportPreviewLoading(false);
            }
        })
        setTogglePDF(!togglePDF);
    };
    // Example with local array
    const groupsList = [
        { id: 'lab', name: 'Lab Report' },
        { id: 'xray', name: 'X-Ray' },
    ];

    const handleDashboardChange = useCallback((event) => {
        console.log(event, "event");
        setPDFURL(null);
        setRowData([]);
        setRowDatanew([]);
        setSearchQuery("");
        setShowAdvanceSearch(false);
        setShowReceipt(false);
        setShowNotes(false);

        if (event.parent_id === 2) {
            setShowBMI(false);
            setShowReport(true);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowNotes(false);
            setShowSecondOpinion(false);
            setShowProfile(false);
            setShowMedicalCondition(false);
            setShowScheduleForChildren(false);
            setShowScheduleByAge(false);
            setShowTrueContraindications(false);
            setShowViewSharedReports(false);
            setActiveTab(event.title);

            dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                const fetchedData = resp.payload.Table;

                // Helper to get unique reports by reportId
                const getUniqueReports = (data) => {
                    const seen = new Set();
                    return data.filter(report => {
                        if (seen.has(report.report_id)) return false;
                        seen.add(report.report_id);
                        return true;
                    });
                };

                let filteredData = [];

                if (event.menu_id === 0) {
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedDatanew);
                    setRowDatanew(formattedDatanew);
                } else {
                    const filteredData = fetchedData.filter(report => report.group_name === event.title);
                    const formattedData = filteredData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                }

                // Apply de-duplication
                const uniqueReports = getUniqueReports(filteredData);

                // Format data
                const formattedData = uniqueReports.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));

                setRowData(formattedData);
                setRowDatanew(formattedData);
            });
        } else if (event.menu_id === 23) {
            setShowBMI(true);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowReport(false);
            setShowBlog(false);
            setShowNotes(false);
            setShowSecondOpinion(false);
            setShowProfile(false);
            setShowMedicalCondition(false);
            setShowScheduleForChildren(false);
            setShowScheduleByAge(false);
            setShowTrueContraindications(false);
            setShowViewSharedReports(false);
        } else if (event.parent_id === 12) {
            if (event.menu_id === 13) {
                setShowReceipt(true);
                setShowBMI(false);
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            }
        } else {
            // Handle other menu items
            if (event.menu_id === 1) {
                setShowSharedReports(false);
                setShowDashBoard(true);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 0) {
                setShowReport(true);
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);

                dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                    const fetchedData = resp.payload.Table;
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                });

            } else if (event.menu_id === 3) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 4) {
                setShowSharedReports(true);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowNotes(false);
                setShowBMI(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 5) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(true);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 8) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(true);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 21) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(true);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 16) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(true);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 17) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(true);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            } else if (event.menu_id === 18) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(true);
                setShowTrueContraindications(false);
                setShowViewSharedReports(false);
            }
            else if (event.menu_id === 19) {
                setShowSharedReports(false);
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(true);
                setShowViewSharedReports(false);
            }
            else if (event.menu_id === 9) {
                setShowDashBoard(false);
                setShowReport(false);
                setShowBlog(false);
                setShowBMI(false);
                setShowNotes(false);
                setShowSecondOpinion(false);
                setShowProfile(false);
                setShowMedicalCondition(false);
                setShowScheduleForChildren(false);
                setShowScheduleByAge(false);
                setShowTrueContraindications(false);
                setShowViewSharedReports(true);
            }
        }
    }, [dispatch, viewReportData]);

    const setLogUserMenuAnalytics = (event) => {
        setRowData([]);
        setRowDatanew([]);
        console.log(event, "event");
        const id = event.id;
        const tab = event.label;
        setActiveTab(tab);
        //   if(id===2){
        setShowReport(true);
        setShowSharedReports(false);
        setShowDashBoard(false);
        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            const fetchedData = resp.payload.Table;

            // Helper to get unique reports by reportId
            const getUniqueReports = (data) => {
                const seen = new Set();
                return data.filter(report => {
                    if (seen.has(report.report_id)) return false;
                    seen.add(report.report_id);
                    return true;
                });
            };

            let filteredData = [];

            if (event.menu_id === 0) {
                filteredData = fetchedData;
            } else {
                filteredData = fetchedData.filter(report => report.group_name === event.title);
            }

            // Apply de-duplication
            const uniqueReports = getUniqueReports(filteredData);

            // Format data
            const formattedData = uniqueReports.map(report => ({
                name: report.report_name,
                date: report.report_date,
                category: report.group_name,
                clinic: report.hospital_name,
                url: report.report_path,
                reportId: report.report_id
            }));

            setRowData(formattedData);
            setRowDatanew(formattedData);
        });

        //  }

    }

    const onRefresh = (activeTab) => {
        const listRequestId = reportsListRequestIdRef.current + 1;
        reportsListRequestIdRef.current = listRequestId;
        searchRequestIdRef.current += 1;
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        setActiveTab(activeTab);
        setIsSelectedBloodWork(activeTab === "Blood work");
        console.log(activeTab, "Name");
        clearReportPreview();
        setRowData([]);
        setRowDatanew([])
        beginReportsGridLoad();
        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            if (listRequestId !== reportsListRequestIdRef.current) {
                return;
            }
            console.log("reportsData", resp.payload);

            if (!resp.payload || resp.payload.length === 0) {
                setRowData([]);
                return;
            } else {
                const fetchedData = resp.payload.Table;

                // Helper to get unique reports by reportId
                const getUniqueReports = (data) => {
                    const seen = new Set();
                    return data.filter(report => {
                        if (seen.has(report.report_id)) return false;
                        seen.add(report.report_id);
                        return true;
                    });
                };

                // Format report object
                const formatReport = (report) => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                });

                if (activeTab === 'All') {
                    const uniqueReports = getUniqueReports(fetchedData);
                    const formattedData = uniqueReports.map(formatReport);
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                } else {
                    const filteredData = fetchedData.filter(report => report.group_name === activeTab);
                    const uniqueFiltered = getUniqueReports(filteredData);
                    const formattedFiltered = uniqueFiltered.map(formatReport);
                    setRowData(formattedFiltered);

                    const uniqueAll = getUniqueReports(fetchedData);
                    const formattedAll = uniqueAll.map(formatReport);
                    setRowDatanew(formattedAll);
                }

            }


        }).finally(() => {
            endReportsGridLoad();
        });

    }

    const includeArchived = (activeTab) => {
        setActiveTab(activeTab);
        console.log(activeTab, "Name");
        setRowData([]);
        setRowDatanew([]);
        setPDFURL(null);

        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            console.log("reportsData", resp.payload);
            const fetchedData = resp.payload.Table; // Use fetched data directly

            // Filter data to include only archived reports
            const archivedData = fetchedData.filter(report => !report.is_archived);
            console.log("archivedData", archivedData)


            const formattedData = archivedData.map(report => ({
                //    if(report.is_archived){
                name: report.report_name,
                date: report.report_date,
                category: report.group_name,
                clinic: report.hospital_name,
                url: report.report_path,
                reportId: report.report_id

                //   }

            }));
            setRowData(formattedData);
            setRowDatanew(formattedData)
            console.log("RowData", rowData)

            //     if (activeTab === 'All') {
            //         setRowData(formattedData); // Update rowData with all archived data
            //     } else {
            //         const filteredData = formattedData.filter(report => report.category === activeTab);
            //         setRowData(filteredData); // Update rowData with filtered archived data
            //     }

            //     setRowDatanew(formattedData); // Update rowDatanew for tab counts
        });
    };

    const setGridData = (event) => {
        const listRequestId = reportsListRequestIdRef.current + 1;
        reportsListRequestIdRef.current = listRequestId;
        searchRequestIdRef.current += 1;
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        const resetViewReportData = {
            ReportGroupName: "",
            ProviderName: "",
            UserID: userId,
            HospitalName: "",
            SearchKey: "",
            ReportDateStart: "",
            ReportDateEnd: "",
            SiteID: "",
            token: isAccess ? menuData.Token : token
        };
        setViewReportData(resetViewReportData)
        setActiveTab(event.name);
        setIsSelectedBloodWork(event.name === "Blood work");
        setSearchQuery("")
        console.log(event.name, "Name");
        clearReportPreview();
        console.log(resetViewReportData, "viewReportData for grid")

        beginReportsGridLoad();
        dispatch(getAllMRSItesReports(resetViewReportData)).then((resp) => {
            if (listRequestId !== reportsListRequestIdRef.current) {
                return;
            }
            console.log("reportsData", resp.payload + resetViewReportData);
            // Use fetched data directly
            if (resp.payload === null || resp.payload === undefined || resp.payload.length === 0) {
                setRowData([]);
                setRowDatanew([]);
            }
            else {
                const fetchedData = resp.payload.Table;
                if (event.name === 'All') {
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData);
                    // Update rowData with formatted data
                } else {
                    const filteredData = fetchedData.filter(report => report.group_name === event.name);
                    const formattedData = filteredData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowDatanew(formattedDatanew);
                    // Update rowData with filtered data
                }

            }


        }).finally(() => {
            endReportsGridLoad();
        });
    };
    const [newMessage, setNewMessage] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    

    const sendnewMessagewhileChat = () => {
        chatHistory.push({
            message: newMessage,
            sender: 'user'
        });
        setNewMessage('');
    }




    const setNewMessagewhileChat = (e) => {
        console.log("setNewMessagewhileChat", e);
        setNewMessage(e);

    }
    const startSpeechRecognitionwhileChat = () => {
        setIsRecording(true);
    }

    

    const clearReportPreview = () => {
        reportPreviewRequestIdRef.current += 1;
        setPDFURL((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });
        setContentType(null);
        setIsReportPreviewLoading(false);
        setSelectedReport(null);
        setSelectedReportName(null);
        setSelectedReportID(null);
    };

    const beginReportsGridLoad = () => {
        reportsGridLoadInflightRef.current += 1;
        setIsReportsGridLoading(true);
    };

    const endReportsGridLoad = () => {
        reportsGridLoadInflightRef.current = Math.max(0, reportsGridLoadInflightRef.current - 1);
        if (reportsGridLoadInflightRef.current === 0) {
            setIsReportsGridLoading(false);
        }
    };

    const onSearch = (event) => {
        const searchValue = event.target.value;
        clearReportPreview();
        setSearchQuery(searchValue);

        const updatedViewReportData = {
            ...viewReportData,
            SearchKey: searchValue
        };
        setViewReportData(updatedViewReportData);
        const searchRequestId = searchRequestIdRef.current + 1;
        searchRequestIdRef.current = searchRequestId;

        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }

        if (searchValue.trim().length < SEARCH_MIN_CHARS) {
            searchRequestIdRef.current += 1;
            if (searchWasActiveRef.current) {
                searchWasActiveRef.current = false;
                const refreshRequestId = searchRequestIdRef.current;
                const refreshViewReportData = {
                    ...updatedViewReportData,
                    SearchKey: ""
                };
                setViewReportData(refreshViewReportData);
                setRowData([])
                setRowDatanew([])
                beginReportsGridLoad();
                dispatch(getAllMRSItesReports(refreshViewReportData)).then((resp) => {
                    if (refreshRequestId !== searchRequestIdRef.current) {
                        return;
                    }
                    console.log("reportsData123", resp.payload);
                    if (resp.payload !== "") {
                        const fetchedData = resp.payload.Table || [];
                        const formattedData = fetchedData.map(report => ({
                            name: report.report_name,
                            date: report.report_date,
                            category: report.group_name,
                            clinic: report.hospital_name,
                            url: report.report_path,
                            reportId: report.report_id
                        }));
                        setRowData(formattedData);
                        setRowDatanew(formattedData);
                    }
                }).finally(() => {
                    endReportsGridLoad();
                });
            }
            return;
        }

        searchWasActiveRef.current = true;
        searchDebounceRef.current = setTimeout(() => {
            searchDebounceRef.current = null;
            console.log(searchValue, "searchValue")
            console.log(updatedViewReportData, "viewReportDataparams")
            setRowData([])
            setRowDatanew([])
            beginReportsGridLoad();
            dispatch(getAllMRSItesReports(updatedViewReportData)).then((resp) => {
                if (searchRequestId !== searchRequestIdRef.current) {
                    return;
                }
                console.log("reportsData123", resp.payload);
                if (resp.payload !== "") {
                    const fetchedData = resp.payload.Table || [];
                    const formattedData = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedData);
                    setRowDatanew(formattedData)

                }
            }).finally(() => {
                endReportsGridLoad();
            });
        }, SEARCH_DEBOUNCE_MS);
    }
    const onClear = (event) => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        searchRequestIdRef.current += 1;
        searchWasActiveRef.current = false;

        setSearchQuery(""); // Clear searchQuery
        const updatedViewReportData = { ...viewReportData, SearchKey: "" }; // Clear SearchKey
        setViewReportData(updatedViewReportData); // Update viewReportData

        console.log("Clearing searchQuery and SearchKey");

        setRowData([]);
        setRowDatanew([]);
        beginReportsGridLoad();
        dispatch(getAllMRSItesReports(updatedViewReportData)).then((resp) => {
            console.log("reportsData123", resp.payload);
            if (resp.payload !== "") {
                const fetchedData = resp.payload.Table;
                const formattedData = fetchedData.map(report => ({
                    name: report.report_name,
                    date: report.report_date,
                    category: report.group_name,
                    clinic: report.hospital_name,
                    url: report.report_path,
                    reportId: report.report_id
                }));
                setRowData(formattedData);
                setRowDatanew(formattedData);
            }
        }).finally(() => {
            endReportsGridLoad();
        });
    };

    const handleSearchClear = () => {
        setSearchQuery("");
        onClear();
    };

    const handleViewTrends = () => {
        setShowViewTrends(true);
        setIsCompare(false);
    }
    const compareParams = {
        reportID: selectedReportID,
        user_id: isAccess ? menuData.user_id : userId, // Use optional chaining for safety
        token: isAccess ? menuData.Token : token
    };

    const handleCompareReports = () => {
        const selectedIds = getCheckedReportIds();
        if (selectedIds.length === 0) {
            console.log('No reports selected for comparison');
            return;
        }
        
        setShowViewTrends(true);
        setIsCompare(true);
        
        // Example of using selected IDs
        selectedIds.forEach(reportId => {
            const compareParams = {
                reportID: reportId,
                user_id: isAccess ? menuData.user_id : userId,
                token: isAccess ? menuData.Token : token
            };
            
            dispatch(mrSitesReportsGetByReportID(compareParams))
                .then((response) => {
                    console.log(`Report ${reportId} data:`, response);
                    const resp = response.payload;
                    const blobUrl = URL.createObjectURL(resp);
                    setPDFURL(blobUrl);
                })
                .catch((error) => {
                    console.error(`Error fetching report ${reportId}:`, error);
                });
        });
    };

    const medColumns = [
        { headerName: "Medication", field: "medication",tooltipField: "medication", headerTooltip: "Medication", flex: 1 },
        { headerName: "Frequency", field: "frequency", tooltipField: "frequency", headerTooltip: "Frequency", flex: 1 },
    ];

    const labColumns = [
        {
            headerName: "Report Name",
            field: "name",
            flex: 1,
            tooltipField: "name",
            headerTooltip: "Report Name",
            wrapText: true,
            autoHeight: true,
            cellClass: 'lab-report-name-wrap',
            cellStyle: {
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere',
                lineHeight: '1.6'
            }
        },
        { headerName: "Report Date", field: "date", flex: 1, tooltipField: "date", headerTooltip: "Report Date" },
    ];




    ///Vitals

    const chartData = {
        lstBPGraph: {
            series: [100, 120, 130, 140, 150, 160],
        },
        lstHeartRateGraph: {
            series: [80, 85, 90, 95, 100, 105],
        },
        // ... other chart data
    };
    const handleAddVitals = () => {
        // Handle adding vitals
    };

    const handleAddMetabolics = () => {
        // Handle adding metabolics
    };

    const handleViewHistory = () => {
        // Handle viewing history
    };

    const handleSlideChange = (eventKey) => {
        // Handle slide change
    };

    const handleDragDropResult = (result) => {
        if (!result.destination) return;
        // Implement your drop logic here
    };

    // eslint-disable-next-line no-undef
    const [showWidgets, setShowWidgets] = useState(true);
    const [sidebarState, setSidebarState] = useState({});

    const toggleSidebar = (sidebarId) => {
        setSidebarState(prev => ({
            ...prev,
            [sidebarId]: !prev[sidebarId]
        }));
    };
    const [showUploadModal, setShowUploadModal] = useState(false);
    const lstUsersWidgets_Tray = [
        {
            id: 1,
            widget_component: 'app-medical-history',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 2,
            widget_component: 'app-allergies',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 3,
            widget_component: 'app-appointments',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 4,
            widget_component: 'app-vaccination',
            widget_component_class: 'col-lg-6 col-12'
        },
        {
            id: 5,
            widget_component: 'app-provider-notes',
            widget_component_class: 'col-lg-6 col-12'
        }
    ];

    const onRemoveUserWidget = (widgetComponent) => {
        setSelectedWidgets(prev =>
            prev.filter(widget => widget.widget_component !== widgetComponent)
        );
    };

    const [lstUsersWidgets_Selected, setSelectedWidgets] = useState([
        {
            id: 1,
            widget_component: 'app-medical-history',
            widget_component_class: 'col-lg-6 col-12'
        }
    ]);

    const handleAddWidget = (widget) => {
        lstUsersWidgets_Selected(prev => [...prev, widget]);
    };

    const IsUserWidget = (widget) => {
        return lstUsersWidgets_Selected.some(w => w.widget_component === widget.widget_component);
    };

    const onAddUserWidget = (widget) => {
        if (!IsUserWidget(widget)) {
            setSelectedWidgets(prev => [...prev, widget]);
        }
    };

    // const seriesData = [
    //     {
    //         name: 'Systolic',
    //         data: [
    //             [new Date('01/01/2024').getTime(), 120],
    //             [new Date('01/02/2024').getTime(), 122],
    //             [new Date('01/03/2024').getTime(), 118],
    //         ],
    //     },
    //     {
    //         name: 'Diastolic',
    //         data: [
    //             [new Date('01/01/2024').getTime(), 80],
    //             [new Date('01/02/2024').getTime(), 78],
    //             [new Date('01/03/2024').getTime(), 82],
    //         ],
    //     },
    // ];

    const [seriesData, setSeriesData] = useState([
        { name: 'Systolic', data: [] },
        { name: 'Diastolic', data: [] },
    ]);

    const [seriesDataforHeartRate, setHeartRateData] = useState([
        { name: 'Heart Rate', data: [] },
    ]);

    const [seriesDataforBloodSugar, setBloodSugarData] = useState([
        { name: 'Blood Sugar', data: [] },])

    const [seriesDataforWeight, setWeightData] = useState([
        { name: 'Weight', data: [] },])

    const [seriesDataforWaistSize, setWaistSizeData] = useState([
        { name: 'Waist Size', data: [] },])

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [reportToDelete, setReportToDelete] = useState(null); // Store { id, name }

    const onDelete = () => {
        setDeleteIcon(true);
        setShowcloseButton(false);
        setDeleteTitle("Are you sure ?");
        setDeleteMessage("You want to delete this report? This action cannot be undone.");
        setShowDeleteConfirm(true);
    };
    const onArchive = () => {
        setArchiveGeader("Confirm Archive");
        setShowcloseButton(true);
        setDeleteIcon(false);
        setDeleteTitle("");
        setDeleteMessage("Are you sure you want to archive this report? It will remain archived for 30 days only, after which it will be permanently deleted.");
        setShowDeleteConfirm(true);
    };

    const handleConfirmDelete = () => {
        if (!reportToDelete?.id) {
            console.error("No report ID found for confirmed deletion.");
            setShowDeleteConfirm(false);
            setReportToDelete(null);
            return;
        }
        const deleteParamsWithId = { ...deleteparams, ReportID: reportToDelete.id };
        console.log(deleteParamsWithId, "deleteparams");

        dispatch(deleteReports(deleteParamsWithId))
            .unwrap()
            .then((payload) => {
                console.log("resp payload", payload);
                if (payload && payload.StatusMessage === "Report deleted successfully.") {
                    setShowDeleteConfirm(false);
                    setPDFURL(null);
                    setSelectedReport(null);
                    setSelectedReportName(null);
                    setSelectedReportID(null);
                    toast.success(`Report "${reportToDelete.name || reportToDelete.id}" deleted successfully.`, {
                        toastId: `report-delete-${reportToDelete.id}`
                    }); // Success toast
                    onRefresh(activeTab); // Refresh the grid
                } else {
                    toast.error(payload?.StatusMessage || "Failed to delete report."); // Error toast
                    setShowDeleteConfirm(false);
                }
            })
            .catch(error => {
                console.error(`Error deleting report with ID ${reportToDelete.id}:`, error);
                toast.error(`Failed to delete report. Error: ${error.message || 'Unknown API error'}`); // Error toast
                setShowDeleteConfirm(false);
            })
            .finally(() => {
                setReportToDelete(null); // Clear the report details
            });
    };

    const handleConfirmArchive = () => {
        console.log("Archive confirmed.");
        setShowDeleteConfirm(false);
        setReportToDelete(null);
        dispatch(archiveReport(archiveparams)).then((resp) => {
            console.log("resp", resp);
            if (resp.payload) {
                dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                    console.log("reportsData", resp.payload + viewReportData);
                    const fetchedData = resp.payload.Table; // Use fetched data directly

                    if (activeTab === 'All') {
                        const formattedData = fetchedData.map(report => ({
                            name: report.report_name,
                            date: report.report_date,
                            category: report.group_name,
                            clinic: report.hospital_name,
                            url: report.report_path,
                            reportId: report.report_id,
                            is_archived: report.is_archived,
                            provider_name: report.provider_name
                        }));
                        setRowData(formattedData);
                        setRowDatanew(formattedData);
                        // Update rowData with formatted data
                    } else {
                        const filteredData = fetchedData.filter(report => report.group_name === activeTab);
                        const formattedData = filteredData.map(report => ({
                            name: report.report_name,
                            date: report.report_date,
                            category: report.group_name,
                            clinic: report.hospital_name,
                            url: report.report_path,
                            reportId: report.report_id,
                            is_archived: report.is_archived,
                            provider_name: report.provider_name
                        }));
                        setRowData(formattedData);
                        const formattedDatanew = fetchedData.map(report => ({
                            name: report.report_name,
                            date: report.report_date,
                            category: report.group_name,
                            clinic: report.hospital_name,
                            url: report.report_path,
                            reportId: report.report_id,
                            is_archived: report.is_archived,
                            provider_name: report.provider_name
                        }));
                        setRowDatanew(formattedDatanew);
                        // Update rowData with filtered data
                    }
                });

            }
        })
    };

    const handleDownload = () => {
        if (!selectedReportID) {
            toast.error("No report selected for download.");
            return;
        }
        console.log("Attempting to download report:", selectedReportID, selectedReportName);
        toast.info("Preparing download...");

        const downloadParams = {
            reportID: selectedReportID,
            user_id: isAccess ? menuData.user_id : userId, // Use optional chaining for safety
            token: isAccess ? menuData.Token : token
        };

        // Check if essential parameters are missing
        if (!downloadParams.user_id || !downloadParams.token) {
            toast.error("Cannot download report: User data or token missing.");
            console.error("Missing user_id or token for download", { userData, token });
            return;
        }

        dispatch(mrSitesReportsGetByReportID(downloadParams))
            .unwrap()
            .then(async (blob) => {
                console.log("Received blob data for download:", blob);

                if (!(blob instanceof Blob)) {
                    console.error("API did not return a valid Blob object.");
                    toast.error("Download failed: Invalid data received.");
                    return;
                }
                if (blob.size === 0) {
                    console.error("Received empty blob.");
                    toast.error("Download failed: Empty file received.");
                    return;
                }

                // 1. Create a temporary URL for the downloaded data (Blob)
                const blobUrl = URL.createObjectURL(blob);

                // 2. Create an invisible link element
                const link = document.createElement('a');
                link.href = blobUrl;

                // 3. Set the 'download' attribute with the correct file extension (PDF vs image)
                const filename = await getReportDownloadFilename({
                    blob,
                    reportName: selectedReportName,
                    reportId: selectedReportID,
                });
                link.download = filename;

                // 4. Simulate a click on the link
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Clean up the link

                // 5. Revoke the temporary URL
                URL.revokeObjectURL(blobUrl);

                toast.success(`Report "${filename}" download initiated.`, {
                    toastId: `report-download-${selectedReportID}`
                });
            })
            .catch((error) => {
                console.error("Error fetching report for download:", error);
                toast.error(`Download failed: ${error.message || 'Could not fetch report data.'}`);
            });
    };

    const handleShare = () => {
        console.log("Sharing report:", selectedReportID, selectedReportName);
        // Implement share logic here
        setShowShareReportDialog(true);
    };

    const handleEdit = () => {
        console.log("Editing report:", selectedReportID, selectedReportName);
        // Implement edit logic here
        setShowEditReportDialog(true);
    };

    const handleCancelDelete = () => {
        console.log("Deletion cancelled.");
        setShowDeleteConfirm(false);
        setReportToDelete(null);
    };
    const [categoryAdvanceSearch, setCategoryAdvanceSearch] = useState([]);

    useEffect(() => {
        console.log(props.isFromDetails, "props.isFromDetails")

        if (props.isFromReports) {
            console.log(viewReportData, "viewReportData112233")
            dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
                const fetchedData = resp.payload.Table;


                console.log(rowData, "formattedData")
                if (fetchedData.length > 0) {
                    const formattedDatanew = fetchedData.map(report => ({
                        name: report.report_name,
                        date: report.report_date,
                        category: report.group_name,
                        clinic: report.hospital_name,
                        url: report.report_path,
                        reportId: report.report_id
                    }));
                    setRowData(formattedDatanew);
                    setRowDatanew(formattedDatanew);


                }


                // // Use fetched data directly
                // const filteredData = fetchedData.filter(report => report.group_name === event.title);
                // const formattedData = filteredData.map(report => ({
                //     name: report.report_name,
                //     date: report.report_date,
                //     category: report.group_name,
                //     clinic: report.hospital_name,
                //     url: report.report_path,
                //     reportId: report.report_id
                // }));
                // setRowData(formattedData);
                // setRowDatanew(formattedData);


            });

        }


        // dispatch(getgridHeaders(params)).then((response) => {
        //     console.log("Response from getgridHeaders:", response);
        //     setGridHeaers(response.payload || []);
        //     const formattedDataforAdvanceSearch = (response.payload || []).map(report => ({
        //         name: report.name,
        //         id: report.id
        //     }));
        //     setCategoryAdvanceSearch(formattedDataforAdvanceSearch);
        // });

        dispatch(getLogUserMenuAnalytics(logUserMenuAnalyticsData)).then((response) => {
            console.log("Response from getLogUserMenuAnalytics:", response + logUserMenuAnalyticsData);
        });

        console.log(props.userID, "props.userID")
        // Fetch medications
        dispatch(getMedicationatDashboard({
            token: isAccess ? menuData.Token : token,
            user_id: userId
        })).then((response) => {
            console.log("Full medication response:", response);
            const rawData = response.payload?.Table || [];
            console.log("Raw Medication Data:", rawData);

            if (!Array.isArray(rawData)) {
                console.error("Expected medication data to be an array but got:", rawData);
                return;
            }

            const formattedData = rawData.map((medication) => ({
                MedicationName: medication.medication_name || medication.medication || '',
                Dose: medication.medication_dose || medication.dose || '',
                MedicationRecurrence: medication.medication_recurrence || medication.frequency || '',
                MedicationStartedFrom: medication.medication_started_from || medication.startedFrom
                    ? new Date(medication.medication_started_from || medication.startedFrom)
                    : new Date(),
                MedicationComments: medication.medication_comments || medication.comments || '',
                Status: medication.medication_status || medication.status || 'Active',

                // Raw backend values for grid display
                medication: medication.medication_name || medication.medication || '',
                dose: medication.medication_dose || medication.dose || '',
                frequency: medication.medication_recurrence || medication.frequency || '',
                startedFrom: medication.medication_started_from || medication.startedFrom || '',
                comments: medication.medication_comments || medication.comments || '',
                status: medication.medication_status || medication.status || 'Active'
            }));

            console.log("Formatted medication data:", formattedData);
            setMedicationData(formattedData);
        }).catch(error => {
            console.error("Error fetching medications:", error);
        });
        const labdata = {
            user_id: isAccess ? menuData.user_id : userId,
            token: isAccess ? menuData.Token : token
        }
        console.log(labdata, "labdata")
        dispatch(getLabResultatDashboard(labdata)).then((response) => {
            console.log("Response from getLabResultatDashboard:", response.payload);
            if (response.payload != undefined) {
                const labResultData = response.payload;
                const formattedData = labResultData.map(labResult => ({
                    name: labResult.report_name,
                    date: labResult.report_date,
                }));
                setLabResults(formattedData);
            }

        });

        dispatch(getVitals(labdata)).then((response) => {
            const vitalsData = response.payload || [];
            console.log("vitalsDatanew", vitalsData);

            const systolicData = [];
            const diastolicData = [];
            const heartRateData = [];
            const bloodSugarData = [];
            const weightData = [];
            const waistSizeData = [];

            vitalsData.forEach(vital => {
                if (vital.LastUpdated && vital.BloodPressure_Systolic && vital.BloodPressure_Diastolic) {
                    systolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Systolic]);
                    diastolicData.push([new Date(vital.LastUpdated).getTime(), vital.BloodPressure_Diastolic]);
                }
                if (vital.LastUpdated && vital.HeartRate) {
                    heartRateData.push([new Date(vital.LastUpdated).getTime(), vital.HeartRate]);
                }
                if (vital.LastUpdated && vital.BloodSugar) {
                    bloodSugarData.push([new Date(vital.LastUpdated).getTime(), vital.BloodSugar]);
                }
                if (vital.LastUpdated && vital.Weight) {
                    weightData.push([new Date(vital.LastUpdated).getTime(), vital.Weight]);
                }
                if (vital.LastUpdated && vital.WaistSize) {
                    waistSizeData.push([new Date(vital.LastUpdated).getTime(), vital.WaistSize]);
                }
            });

            setSeriesData([
                { name: 'Systolic', data: systolicData },
                { name: 'Diastolic', data: diastolicData },
            ]);
            setHeartRateData([
                { name: 'Heart Rate', data: heartRateData },
            ]);
            setBloodSugarData([
                { name: 'Blood Sugar', data: bloodSugarData },
            ]);
            setWeightData([
                { name: 'Weight', data: weightData },
            ]);
            setWaistSizeData([
                { name: 'Waist Size', data: waistSizeData },
            ]);

            const latestVital = vitalsData[vitalsData.length - 1] || {};
            setVitalsValues({
                BloodPressure: latestVital.BloodPressure_Systolic && latestVital.BloodPressure_Diastolic
                    ? `${latestVital.BloodPressure_Systolic}/${latestVital.BloodPressure_Diastolic}`
                    : "N/A",
                HeartRate: latestVital.HeartRate || "N/A",
                BloodSugar: latestVital.BloodSugar || "N/A",
                Weight: latestVital.Weight || "N/A",
                WaistSize: latestVital.WaistSize || "N/A",
            });
        });


        if (MenuData && Array.isArray(MenuData)) {
            const updatedNavItems = MenuData.map(item => ({
                menu_id: item.menu_id,
                title: item.title || "Untitled",
                url: item.url || "#",
                parent_id: item.parent_id || null,
                sort_order: item.sort_order || 0,
                type: item.type || ""
            }));
            setNavItems(updatedNavItems);
        }

        if (FamilyData && Array.isArray(FamilyData)) {
            const updatedNavItemsFamily = FamilyData.map(item => ({
                dropdown_display_name: item.dropdown_display_name,
                family_account_id: item.family_account_id || "Untitled",
                relation_type_id: item.relation_type_id || "#",
                relation_type_name: item.relation_type_name || null,
                relative_name: item.relative_name || 0,
                user_id: item.user_id || ""
            }));
            setFamilyItems(updatedNavItemsFamily);
        }

        // Re-implement fullscreen listener setup
        const handleFullscreenChange = () => {
            console.log("Fullscreen change detected. Is fullscreen:", !!document.fullscreenElement);
            setIsFullscreen(!!document.fullscreenElement);
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
        document.addEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
        document.addEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge

        // Cleanup listener on component unmount
        return () => {
            console.log("Cleaning up fullscreen listener.");
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange); // Firefox
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange); // IE/Edge
        };
    }, [showDashboard, dispatch, token, logUserMenuAnalyticsData, MenuData, FamilyData, props.isFromDetails, props.isFromReports]); // Add necessary dependencies if they affect the setup




    const onAdvanceSearch = () => {
        const panel = document.querySelector('.advanceSearchcontainer');
        if (panel) {
            panel.style.transition = 'transform 0.3s ease-in-out';
            panel.style.transform = 'translateX(0)';
        }
        setShowAdvanceSearch(true); // Ensure state is updated immediately
        dispatch(getProviderforAdvanceSearch({
            ...viewReportData,
            token: isAccess ? menuData.Token : token
        }))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "provider");
                setProvider(resp.Table);
            })
            .catch((error) => {
                console.error("Error fetching provider data:", error);
            });
        dispatch(getHospitalsforAdvanceSearch({
            ...viewReportData,
            token: isAccess ? menuData.Token : token
        }))
            .unwrap()
            .then((resp) => {
                console.log(resp.Table, "Hospitals");
                setHospital(resp.Table);
            })
            .catch((error) => {
                console.error("Error fetching hospital data:", error);
            });
    };
    const handleCategoryChange = (selected) => {
        console.log("handleCategoryChange received:", selected); // Log the raw input
        setSelectedCategories(selected);

        console.log(selected, "selected")

        const selectedValues = selected.map(item => { // Log each item and its id
            console.log("Mapping item:", item);
            console.log("Item ID:", item?.id);
            return item?.id; // Use optional chaining for safety
        });

        console.log("Selected Categories IDs:", selectedValues); // Changed log label

        // Update viewReportData with selected categories
        setViewReportData(prevData => ({
            ...prevData,
            ReportGroupName: selectedValues.filter(id => id !== undefined).join(',') // Filter out undefined IDs before joining
        }));
        console.log("Updated viewReportData:", { ...viewReportData, ReportGroupName: selectedValues.filter(id => id !== undefined).join(',') }); // Filter out undefined IDs

        console.log("Selected Categories:", selectedCategories + '--' + selected);

    };

    const handleProviderChange = (selected) => {
        setSelectedProviders(selected);
        console.log("Selected Providers:", selected);
    };

    const handleHospitalChange = (selected) => {
        setSelectedHospitals(selected);
        console.log("Selected Hospitals:", selected);
    };


    const onApplySearch = () => {
        console.log(viewReportData, "viewReportData for advance search")
        dispatch(getAllMRSItesReports(viewReportData)).then((resp) => {
            console.log("resp", resp);
            //     console.log("reportsData", resp.payload);
            const fetchedData = resp.payload?.Table || [];
            // Use fetched data directly
            //    if (activeTab === 'All') {
            const formattedData = fetchedData.map(report => ({
                name: report.report_name,
                date: report.report_date,
                category: report.group_name,
                clinic: report.hospital_name,
                url: report.report_path,
                reportId: report.report_id
            }));
            setRowData(formattedData);
            setRowDatanew(formattedData);// Update rowData with formatted data
            // } else {
            //     const filteredData = fetchedData.filter(report => report.group_name === activeTab);
            //     const formattedData = filteredData.map(report => ({
            //         name: report.report_name,
            //         date: report.report_date,
            //         category: report.group_name,
            //         clinic: report.hospital_name,
            //         url: report.report_path,
            //         reportId: report.report_id
            //     }));
            //     setRowData(formattedData);
            //     const formattedDatanew = fetchedData.map(report => ({
            //         name: report.report_name,
            //         date: report.report_date,
            //         category: report.group_name,
            //         clinic: report.hospital_name,
            //         url: report.report_path,
            //         reportId: report.report_id
            //     }));
            //     setRowDatanew(formattedDatanew);
            //     // Update rowData with filtered data
            // }
        })
        setSearchQuery("");
        setShowAdvanceSearch(false);
        setViewReportData({
            ReportGroupName: "",
            ProviderName: "",
            UserID: userId,
            HospitalName: "",
            SearchKey: searchQuery,
            ReportDateStart: "",
            ReportDateEnd: "",
            token: isAccess ? menuData.Token : token
        })
        console.log(viewReportData, "after")
    }
    const handleProfile = () => {
        setShowProfile(true);
    }
    const showAccountSettings = (item) => {
        console.log(item, "item")

        if (item == 'profile') {
            setPDFURL(null)
            setRowData([])
            setRowDatanew([])
            setSearchQuery("")
            setShowAdvanceSearch(false)
            setShowReceipt(false)
            setShowProfile(true);
            setShowBMI(false);
            setShowReport(false);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowSharedReports(false);
            setShowDashBoard(false);
            setShowReport(false);
            setShowBlog(false);
            setShowBMI(false);
            setActiveTab(null);
            setShowSecondOpinion(false);
            setShowMedicalCondition(false);
            setShowScheduleForChildren(false);
            setShowScheduleByAge(false);
            setShowTrueContraindications(false);

        }

    }

    // <<< Re-implement onFullScreenToggle to use container ref and listener
    const onFullScreenToggle = () => {
        const elem = previewContainerRef.current; // Use the container ref
        if (!elem) {
            console.error("Preview container element not found for fullscreen toggle.");
            return;
        }

        if (!document.fullscreenElement) {
            elem.requestFullscreen()
                .then(() => { /* State update handled by listener */ })
                .catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
                    .then(() => { /* State update handled by listener */ })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                    });
            } else {
                console.error("Exit fullscreen is not supported by this browser.");
            }
        }
    };

    const [draggedWidget, setDraggedWidget] = useState(null);
    const [widgetPositions, setWidgetPositions] = useState({
        medications: { order: 0, col: 'col-md-3' },
        labResults: { order: 1, col: 'col-md-3' },
        vitals: { order: 2, col: 'col-md-6' }
    });

    const handleWidgetDragStart = (e, widgetType) => {
        e.dataTransfer.setData("widgetType", widgetType);
        setDraggedWidget(widgetType);
        // Add visual feedback
        e.currentTarget.style.opacity = "0.5";
    };

    const handleWidgetDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "2px dashed var(--pmr-secondary)";
    };

    const handleWidgetDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
    };

    const handleWidgetDrop = (e, targetWidgetType) => {
        e.preventDefault();
        e.currentTarget.style.border = "none";
        e.currentTarget.style.opacity = "1";

        if (draggedWidget && draggedWidget !== targetWidgetType) {
            // Get current positions
            const draggedPos = widgetPositions[draggedWidget];
            const targetPos = widgetPositions[targetWidgetType];

            // Swap positions
            setWidgetPositions(prev => ({
                ...prev,
                [draggedWidget]: { ...prev[draggedWidget], order: targetPos.order },
                [targetWidgetType]: { ...prev[targetWidgetType], order: draggedPos.order }
            }));
        }

        setDraggedWidget(null);
    };

    const handleWidgetDragEnd = (e) => {
        e.currentTarget.style.opacity = "1";
    };

    // Sort widgets based on their order
    const getSortedWidgets = () => {
        const allWidgets = Object.entries(widgetPositions)
            .sort(([, a], [, b]) => a.order - b.order)
            .map(([type]) => type);

        // If isAccess is true, only return medication, labResults, and vitals
        if (isAccess) {
            return allWidgets.filter(widget =>
                ['medications', 'labResults', 'vitals'].includes(widget)
            );
        }

        return allWidgets;
    };

    return (
        <>
            {!isProvider && (
                <React.Fragment>
                    <div className="fixed-top" style={{ verticalAlign: "center", flex: 1, alignContent: 'center', alignItems: 'center' }}>
                        <div className="shadow-lg">
                            <TopHeader showAccountSettings={showAccountSettings} />
                        </div>
                        <div className="py-2 mx-4">
                            <CTNavbar
                                navItems={navItems}
                                familyItems={familyItems}
                                activeTab={activeTab}
                                setDashboard={handleDashboardChange}
                                setActiveTab={setActiveTab}
                                isAccess={isAccess}
                            />
                        </div>
                    </div>
                    <div style={{ height: isAccess ? "20px" : "80px" }}></div>
                </React.Fragment>
            )}

            <div style={{ backgroundColor: "#fffff" }}>
                <div className="container-fluid mt-5">
                    {showDashboard && (
                        <div className="row d-flex justify-content-between align-items-center p-0 mb-0">
                            <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4">
                                {(!isProvider && !isAccess) && (
                                    <span>
                                        Have a report(s) to upload?&nbsp;
                                        <a
                                            href="#"
                                            style={{ color: "var(--pmr-danger)", textDecoration: "underline", fontWeight: "bold" }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setShowUploadModal(true);
                                            }}
                                        >
                                            Click here
                                        </a>
                                    </span>
                                )}

                                {isProvider && (
                                    <div className="d-flex flex-column align-items-start mb-1">
                                        <button
                                            className="btn mb-1 text-capitalize p-2 fixed-back-button"
                                            onClick={props.onBack}
                                            style={{
                                                borderColor: 'var(--pmr-primary)',
                                                backgroundColor: 'var(--pmr-primary)',
                                                color: '#fff',
                                                display: 'inline-block',
                                                fontWeight: 600,
                                                textAlign: 'center',
                                                verticalAlign: 'middle',
                                                userSelect: 'none',
                                                WebkitUserSelect: 'none',
                                                MozUserSelect: 'none',
                                                border: '1px solid var(--pmr-primary)',
                                                padding: '.9rem 2.2rem',
                                                fontSize: '1.1rem',
                                                lineHeight: 1,
                                                borderRadius: '.358rem',
                                                transition: 'color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,background 0s,border 0s',
                                                width: 'auto',
                                                minWidth: '120px',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <span style={{ fontSize: '18px', lineHeight: 1 }}> <i className="fa fa-arrow-left"></i> </span> Back
                                        </button>
                                        <span style={{ fontWeight: 'bold', marginTop: '2px' }}>
                                            <span>
                                                You are viewing{' '}
                                                {props.patientName ? (
                                                    <>
                                                    <span className="text-danger" style={{ fontSize: '1.4146rem' }}>{props.patientName}</span> <span>{'details'}</span></>
                                                ) : (
                                                    'details'
                                                )}
                                            </span>
                                        </span>
                                    </div>
                                )}
                            </div>

                            {(!isProvider || props.isFromDetails || isAccess) && (
                                <>

                                    <div className="text-start col-md-8 col-lg-8 col-sm-8 col-xs-8 d-flex justify-content-start align-items-center gap-4 iconMargin p-0 mb-0">
                                        <div className="menu-row">
                                            {menuItems.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="menu-card"
                                                    onClick={() => setLogUserMenuAnalytics(item)}
                                                >
                                                    <span className="menu-icon-bg">
                                                        {item.icon}
                                                    </span>
                                                    <p className="menu-label">{item.label}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* <div className="row mt-3 medicationContainer">
                                        {getSortedWidgets().map((widgetType) => {
                                            // Only render widgets if they are in the allowed list for isAccess
                                            if (isAccess && !['medications', 'labResults', 'vitals'].includes(widgetType)) {
                                                return null;
                                            }

                                            switch (widgetType) {
                                                case 'medications':
                                                    return (
                                                        <div
                                                            key="medications"
                                                            className={widgetPositions.medications.col}
                                                            draggable={!isAccess}
                                                            onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'medications')}
                                                            onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                            onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                            onDrop={(e) => !isAccess && handleWidgetDrop(e, 'medications')}
                                                            onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                            style={{ cursor: isAccess ? 'default' : 'move' }}
                                                        >
                                                            <div className="card shadow-lg p-0">
                                                                <h6 className="card-header mb-0 fw-bold text-capitalize">Medications</h6>
                                                                <div className="card-body p-0">
                                                                    <CTGrid
                                                                        rowData={medications}
                                                                        columnDefs={medColumns}
                                                                        onAddEditable={!isAccess ? "Add/Edit Medications" : undefined}
                                                                        onAddEdit={!isAccess}
                                                                        label={!isAccess ? "Add/Edit" : undefined}
                                                                        hieght={250}
                                                                    />
                                                                </div>
                                                                {!isProvider && !isAccess && (
                                                                    <div className="card-footer text-start d-flex p-x4">
                                                                        <span variant="text" className="modalfooterclickeventtext" onClick={handleAddClick}>Add</span>
                                                                        <span className="mx-2 text-muted">|</span>
                                                                        <span variant="text" className="modalfooterclickeventtext" onClick={handleAddClick}>Edit</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );

                                                case 'labResults':
                                                    return (
                                                        <div
                                                            key="labResults"
                                                            className={widgetPositions.labResults.col}
                                                            draggable={!isAccess}
                                                            onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'labResults')}
                                                            onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                            onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                            onDrop={(e) => !isAccess && handleWidgetDrop(e, 'labResults')}
                                                            onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                            style={{ cursor: isAccess ? 'default' : 'move' }}
                                                        >
                                                            <div className="card shadow-lg p-0" style={isProvider ? { height: '350px', minHeight: '350px', maxHeight: '350px' } : { height: '390px', minHeight: '390px', maxHeight: '390px' }}>
                                                                <h6 className="card-header mb-0 fw-bold text-capitalize">Lab Results</h6>
                                                                <div className="card-body p-0" style={isProvider ? { height: '180px', minHeight: '180px', maxHeight: '180px' } : { height: '200px', minHeight: '200px', maxHeight: '200px' }}>
                                                                    <CTGrid rowData={labResults} columnDefs={labColumns} hieght={isProvider ? 250 : 295} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );

                                                case 'vitals':
                                                    return (
                                                        <div
                                                            key="vitals"
                                                            className={widgetPositions.vitals.col}
                                                            draggable={!isAccess}
                                                            onDragStart={(e) => !isAccess && handleWidgetDragStart(e, 'vitals')}
                                                            onDragOver={!isAccess ? handleWidgetDragOver : undefined}
                                                            onDragLeave={!isAccess ? handleWidgetDragLeave : undefined}
                                                            onDrop={(e) => !isAccess && handleWidgetDrop(e, 'vitals')}
                                                            onDragEnd={!isAccess ? handleWidgetDragEnd : undefined}
                                                            style={{ cursor: isAccess ? 'default' : 'move' }}
                                                        >
                                                            <AddVitals
                                                                header="Vitals"
                                                                title="Blood Pressure"
                                                                height={200}
                                                                seriesData={seriesData}
                                                                BloodPressure={vitalsValues.BloodPressure}
                                                                heartRate={vitalsValues.HeartRate}
                                                                Bloodsugar={vitalsValues.BloodSugar}
                                                                weight={vitalsValues.Weight}
                                                                waist={vitalsValues.WaistSize}
                                                                type="area"
                                                                heartRateData={seriesDataforHeartRate}
                                                                bloodSugarData={seriesDataforBloodSugar}
                                                                waistData={seriesDataforWaistSize}
                                                                weightData={seriesDataforWeight}
                                                                onClickHandler={!isAccess ? () => handleAddVitals(vitalsValues) : undefined}
                                                                Bpheader="Blood Pressure"
                                                                heartRateheader="Heart Rate"
                                                                bloodSugarDataheader="Blood Sugar"
                                                                wieghtDataheader="Weight"
                                                                waistheader="Waist Size"
                                                            />
                                                        </div>
                                                    );

                                                default:
                                                    return null;
                                            }
                                        })}
                                    </div> */}
                                    {!isAccess && (
                                        <div style={{ position: "relative",paddingBottom:50}}>
                                            <WidgetsDashboard userId={userId} />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    )}

                    {(showReport || (props.isFromReports && isProvider)) && (
                        <ReportDisplaySection
                            searchQuery={searchQuery}
                            onSearchChange={(e) => onSearch(e)}
                            onSearchClear={handleSearchClear}
                            onAdvanceSearchClick={onAdvanceSearch}
                            onIncludeArchivedToggle={() => includeArchived(activeTab)}
                            onRefreshClick={() => onRefresh(activeTab)}
                            gridHeaders={gridHeaders}
                            activeTab={activeTab}
                            onTabClick={(tab) => setGridData(tab)}
                            rowDatanew={rowDatanew}
                            gridRef={gridRef}
                            rowData={rowData}
                            columnDefs={columnDefs}
                             onRowClicked={onRowClicked}
                            previewContainerRef={previewContainerRef}
                            isFullscreen={isFullscreen}
                            pdfUrl={pdfUrl}
                            contentType={contentType}
                            isReportsGridLoading={isReportsGridLoading}
                            isReportPreviewLoading={isReportPreviewLoading}
                            selectedReport={selectedReport}
                            selectedReportName={selectedReportName}
                            selectedReportID={selectedReportID}
                            onFullScreenToggle={onFullScreenToggle}
                            onDeleteReport={onDelete}
                            onArchiveReport={onArchive}
                            onDownloadReport={handleDownload}
                            onShareReport={handleShare}
                            onEditReport={handleEdit}
                            iframeRef={iframeRef}
                            isSelectedBloodWork={isSelectedBloodWork}
                            onViewTrends={handleViewTrends}
                            onCompareReports={handleCompareReports}
                            hideAdvancedSearchOption
                            hideSummaryButton
                        />
                    )}

                    {showSharedReports && <SharedReports />}
                    {showBlog && <Blog />}
                    {showBMI && <BMIScreen />}
                    {showReceipt && <Receipts />}
                    {showNotes && <NoteApp />}
                    {showProfile && <AccountSettings />}
                    {showSecondOpinion && <SecondOpinion />}
                    {showMedicalCondition && <MedicalCondition />}
                    {showScheduleForChildren && <ScheduleForChildren />}
                    {showScheduleByAge && <ScheduleByAge />}
                    {showTrueContraindications && <TrueContraindications />}
                    {showViewSharedReports && <ViewSharedReports />}

                    {showAdvanceSearch && (
                        <div className="position-fixed top-0 end-0 bg-light shadow-lg sliding-div">
                            <div className="d-flex justify-content-between align-items-center">
                                <h5 className="text-start fw-bold fs-20">Advanced Search</h5>
                            </div>
                            <div className="p-3">
                                <CTDropDownMulti
                                    data={categoryAdvanceSearch}
                                    placeholder="Search by Category"
                                    setSelectedOptions={(e) => handleCategoryChange(e)}
                                    value={selectedCategories}
                                />
                                <CTDropDownMulti
                                    data={provider}
                                    placeholder="Search by Proivder"
                                    onChange={(selected) => console.log("Selected:", selected)}
                                />
                                <CTDropDownMulti
                                    data={hospitals}
                                    placeholder="Search by Clinic/Diagnosis Center"
                                    onChange={(selected) => console.log("Selected:", selected)}
                                />
                                <CTDatePickerRange />
                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        className="btn btn-primary me-2"
                                        style={{ textTransform: "none", fontSize: "14px" }}
                                        onClick={() => console.log("Apply clicked")}
                                    >
                                        Apply Search
                                    </button>
                                    <button
                                        className="btn btn-warning"
                                        style={{ textTransform: "none", fontSize: "14px", fontWeight: "bold" }}
                                        onClick={() => console.log("Reset clicked")}
                                    >
                                        Clear Search
                                    </button>
                                </div>
                                <div className="d-flex justify-content-center align-items-center mt-3">
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => setShowAdvanceSearch(false)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* Modals and Dialogs */}
                {showDeleteConfirm && (
                    <ConfirmationPopup
                        show={showDeleteConfirm}
                        onHide={handleCancelDelete}
                        onConfirm={deleteIcon ? handleConfirmDelete : handleConfirmArchive}
                        handleClose={handleCancelDelete}
                        icon={deleteIcon}
                        title={deleteTitle}
                        message={deleteMessage}
                        header={archiveGeader}
                        closeButton={showcloseButton}
                    />
                )}

                {showShareReportDialog && (
                    <ShareReportDialog
                        show={showShareReportDialog}
                        onHide={() => setShowShareReportDialog(false)}
                        reportName={selectedReportName}
                        reportId={selectedReportID}
                        reportLink={pdfUrl}
                        onShareReport={handleShare}
                    />
                )}

                {showEditReportDialog && (
                    <EditReportDialog
                        show={showEditReportDialog}
                        onClose={() => setShowEditReportDialog(false)}
                        initialData={data}
                    />
                )}
            </div >

            {/* Main Modals */}
            < UploadReports
                show={showUploadModal}
                onHide={() => setShowUploadModal(false)}
            />

            < MedicationsModal
                show={showModal}
                onHide={handleModalClose}
                medications={medications}
                onSave={handleSaveMedications}
            />
            {
             showLiveChat && (
                    <LiveChat
                        hideChat={() => setShowLiveChat(false)}
                        lstMsgs={chatHistory}
                        setNewMessage={(e) => setNewMessagewhileChat(e)}
                        newMessage={newMessage}
                        sendMessage={sendnewMessagewhileChat}
                        isRecording={isRecording}
                        startSpeechRecognition={startSpeechRecognitionwhileChat}
                    />
                )
            }
                      {showViewTrends && (
                <ViewTrends
                    show={showViewTrends}
                    onHide={() => setShowViewTrends(false)}
                    user_id={userId}
                    token={token}
                    isCompare={isCompare}
                    compareReportOne={compareReportOne}
                    compareReportTwo={compareReportTwo}
                />
            )}
        </>
    )

}



export default ViewReports;